"use client";

import { c as _c } from "react/compiler-runtime";
import Avatar from "sigma-avatars";
import OptimizedImage from "@/components/optimized-image";
import { SigmaDigitBackdrop } from "@/components/sigma-digit-backdrop";
interface AuthHeroPanelProps {
  oauthClient?: {
    clientName: string;
    ownerBapId: string;
  } | null;
  clientImageUrl?: string | null;
}

/**
 * Right-hand panel shared by /signup and /login on desktop: the gradient,
 * the digit-field backdrop with the σ glyph, one line of copy, and the
 * requesting OAuth client when there is one.
 */
export function AuthHeroPanel(t0) {
  const $ = _c(9);
  const {
    oauthClient,
    clientImageUrl
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 bg-gradient-to-br from-primary/15 via-background to-background" />;
    t2 = <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,hsl(var(--foreground)/0.12)_1px,transparent_0)] [background-size:24px_24px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />;
    t3 = <SigmaDigitBackdrop />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-2"><p className="font-semibold text-2xl tracking-tight">Your key is your account.</p><p className="max-w-sm text-muted-foreground text-sm">Sign in anywhere with a signature. Nothing to verify, nothing to hand over.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== clientImageUrl || $[5] !== oauthClient) {
    t5 = oauthClient ? <div className="rounded-xl border bg-background/60 p-4 backdrop-blur"><div className="flex items-center gap-3">{clientImageUrl ? <OptimizedImage alt={oauthClient.clientName} className="h-10 w-10 rounded-full ring-1 ring-border" height={40} quality={90} src={clientImageUrl} width={40} /> : <div className="h-10 w-10 overflow-hidden rounded-full bg-muted ring-1 ring-border"><Avatar colors={["var(--chart-1)", "var(--chart-2)", "var(--chart-3)", "var(--chart-4)", "var(--chart-5)"]} name={oauthClient.ownerBapId} size={40} variant="pixel" /></div>}<div className="min-w-0"><p className="truncate font-medium text-sm">{oauthClient.clientName}</p><p className="text-muted-foreground text-xs">is requesting access to your identity</p></div></div></div> : null;
    $[4] = clientImageUrl;
    $[5] = oauthClient;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="relative hidden overflow-hidden bg-muted lg:block">{t1}{t2}{t3}<div className="relative flex h-full flex-col justify-end gap-6 p-10">{t4}{t5}</div></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}